import { Box, Flex, Icon, Link } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { Gdpr, Soc } from '@/assets/icons/colored';

export const TradeMarkFooter = ({
  isSignUp = false,
  trademarkFooterStyles,
}) => {
  const currentYear = new Date().getFullYear();
  const footerConfig = {
    tradeMarkText: `©${currentYear} All Rights Reserved. Kula® is a registered trademark.`,
    cookieUrl: 'https://www.kula.ai/cookie-policy',
    privacyUrl: 'https://www.kula.ai/privacy-policy',
    termsUrl: 'https://www.kula.ai/terms-of-use',
  };

  const { tradeMarkText, cookieUrl, privacyUrl, termsUrl } = footerConfig;
  const SignUpTradeMarkFooter = () => (
    <Box
      display="flex"
      flexDirection="column"
      textAlign="center"
      alignItems="center"
      gap="6px"
			px={{ base: 2, md: 0 }}
    >
      <KText fontSize={{ base: '9px', md: '10px' }} color="secondary-700" lineHeight="1.3">
        By signing up I accept the{' '}
        <Link href={termsUrl} target="_blank" color="primary-500">
          Terms of Service
        </Link>{' '}
        and the{' '}
        <Link href={privacyUrl} target="_blank" color="primary-500" mr="4px">
          Privacy Policy
        </Link>
      </KText>
      <KText  fontSize={{ base: '9px', md: '10px' }}color="secondary-700" lineHeight="1.3">
        {tradeMarkText}
      </KText>
    </Box>
  );

  const DefaultTradeMarkFooter = () => {
    return (
      <Flex
        direction={{ base: 'column', md: 'row' }} wrap="wrap"
        gap={{ base: '4px', md: '6px' }}
        alignItems="center"
        justifyContent="center"
				textAlign="center"
        px={{ base: 2, md: 0 }}
        {...trademarkFooterStyles}
      >
        <KText
          fontSize={{ base: '9px', md: '10px' }}
          color="secondary-700"
          whiteSpace="nowrap"
          lineHeight="1.3"
        >
          {tradeMarkText}
        </KText>
        <KText fontSize={{ base: '9px', md: '10px' }} whiteSpace="nowrap" lineHeight="1.2">
          <Link href={cookieUrl} target="_blank" color="primary-500" mr="4px">
            Cookie Policy,
          </Link>
          <Link href={privacyUrl} target="_blank" color="primary-500" mr="4px">
            Privacy,
          </Link>
          <KText fontSize={{ base: '9px', md: '10px' }} color="secondary-700" as="span" mr="4px">
            and
          </KText>
          <Link href={termsUrl} target="_blank" color="primary-500">
            Terms
          </Link>
        </KText>
      </Flex>
    );
  };

  return (
    <Flex flexDirection="column" gap={{ base: '6px', md: '8px' }} mb={isSignUp ? '-12px' : '20px'} textAlign="center">
      <Flex justifyContent="center"  gap={{ base: '8px', md: '12px' }} alignItems="center"  flexDirection={{ base: 'column', md: 'row' }}>
        <KText size="sm-bold" color="base-black"  fontSize={{ base: '11px', md: '13px' }}>
          Trusted by:
        </KText>
				 <Flex
          gap={{ base: '6px', md: '12px' }}
          alignItems="center"
          justifyContent="center"
        >
        <Icon as={Soc} width="45px" height="45px" />
        <Icon as={Gdpr} width="98px" height="40px" />
      </Flex>
			</Flex>
      {isSignUp ? <SignUpTradeMarkFooter /> : <DefaultTradeMarkFooter />}
    </Flex>
  );
};
